<template>
	<div
		class="modal fade"
		ref="modal"
		tabindex="-1"
		role="dialog"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-panel" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h1 class="modal-title">
						<i class="sk-icon-tag-solid"></i>
						Promo Code
					</h1>
					<button
						class="modal-close"
						aria-label="Close"
						@click="close"
					>
						<i class="sk-icon-times"></i>
					</button>
				</div>
				<div class="modal-body">
					<div class="modal-subtitle">
						Add your coupon or voucher code below
					</div>
					<SkInput
						:name="'Promo Code'"
						:placeholder="'ABCDE'"
						v-model="couponValue"
					/>
					<button
						type="button"
						class="button button-primary"
						data-dismiss="modal"
						data-cy="add-coupon-button"
						@click="validateCoupon"
					>
						Add Promo Code
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-body {
	align-items: flex-start;
	padding: 20px 5px;
}

.modal-header {
	height: 55px;
	border: 1px solid var(--gR-white2);
}

.modal-subtitle {
	font-size: 14px;
	margin-bottom: 47px;
	margin-left: 15px;
}

.modal-subtitle,
.sk-select {
	margin-bottom: 60px;
}

.modal-body button.button.button-primary {
	max-width: 100%;
	margin: 5 5px;
}

.sk-input-wrapper {
	min-width: 100%;
	margin-bottom: 60px;
}
</style>

<script>
import SkInput from "@/components/common/SkInput.vue"
import { eventBus, EventBusEvents } from "@/eventBus"
import { NotificationType } from "@/enums/NotificationType"

export default {
	name: "CouponModal",
	components: {
		SkInput
	},
	data: function () {
		return {
			couponValue: ""
		}
	},
	methods: {
		open() {
			this.couponValue = ""
			$(this.$refs.modal).modal("show")
		},
		close() {
			$(this.$refs.modal).modal("hide")
		},
		validateCoupon: function () {
			this.couponValue = this.couponValue.trim()
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Apply Coupon Clicked",
				data: {
					code: this.couponValue
				}
			})
			this.$store
				.dispatch("calcDiscount", this.couponValue)
				.then(() => {
					this.$store.dispatch("sendMixpanelEvent", {
						msg: "Coupon Validated",
						data: {
							code: this.couponValue
						}
					})
				})
				.catch((e) => {
					eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
						message: e ? e : "Invalid or Expired Coupon",
						type: NotificationType.ERROR
					})
					this.$store.dispatch("sendMixpanelEvent", {
						msg: "Coupon Invalid",
						data: {
							code: this.couponValue
						}
					})
				})
		}
	}
}
</script>